/** 返回不可领取原因；仅热区配置允许忽略尚未开始条件，其余入口仍要求当前可领取。 */
export function couponUnavailableReason(coupon, now = Math.floor(Date.now() / 1000), allowUpcoming = false) {
  if (!coupon) return '优惠券不存在'
  const enabled = coupon.manual_claim_enabled === true || Number(coupon.manual_claim_enabled) === 1
  if (!enabled) return '未开启手动领取'
  if (coupon.data_source && coupon.data_source !== 'LOCAL') return '迁移券不可重新领取'
  if (!['FREE_GET', 'ACTIVITY_GIVE', 'POINT_EXCHANGE'].includes(coupon.type)) return '券类型不支持领取'
  if (coupon.use_channel === 'OFFLINE') return '仅限门店线下使用'
  if (!allowUpcoming && coupon.start_time && Number(coupon.start_time) > now) return '尚未生效'
  if (coupon.end_time && Number(coupon.end_time) < now) return '已失效'
  if (Number(coupon.create_num || 0) <= Number(coupon.received_num || 0)) return '已领完'
  return ''
}

/** 热区允许提前配置未生效券，其他领取开关、来源、渠道、库存及到期条件仍须满足。 */
export function couponLinkUnavailableReason(coupon, now = Math.floor(Date.now() / 1000)) {
  return couponUnavailableReason(coupon, now, true)
}

/** 以字符串保存模板编号，拒绝已丢失精度的数字及超出Long范围的编号。 */
export function normalizeCouponLinkId(value) {
  if (typeof value === 'number' && !Number.isSafeInteger(value)) return ''
  const id = String(value)
  if (!/^[1-9]\d{0,18}$/.test(id)) return ''
  return id.length === 19 && id > '9223372036854775807' ? '' : id
}
